var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-loader-background",class:{
  'bb-loader-background_fill': _vm.fill,
  'bb-loader-background_block': _vm.blockMode
}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-loader"},[_c('div',{staticClass:"bb-loader__face"},[_c('div',{staticClass:"bb-loader__circle"})]),_vm._v(" "),_c('div',{staticClass:"bb-loader__face"},[_c('div',{staticClass:"bb-loader__circle"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5476d430","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Loaders/LoaderFly.vue
// module id = null
// module chunks = 